import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'reactstrap';
import './Unauthorized.scss';

const Unauthorized = () => {
    const navigate = useNavigate();

    return (
        <Container className="unauthorized-container">
            <Row className="justify-content-center align-items-center min-vh-100">
                <Col md="6" className="text-center">
                    <Card className="unauthorized-card">
                        <div className="unauthorized-icon">
                            <i className="fas fa-ban"></i>
                        </div>

                        <h1>Access Denied</h1>

                        <p className="unauthorized-message">
                            You don't have permission to access the admin panel.
                            This area is restricted to administrators only.
                        </p>

                        <div className="unauthorized-actions">
                            <Button
                                color="primary"
                                onClick={() => navigate('/admin/login')}
                                className="me-3"
                            >
                                <i className="fas fa-sign-in-alt me-2"></i>
                                Go to Login
                            </Button>

                            <Button
                                color="secondary"
                                onClick={() => navigate('/')}
                                outline
                            >
                                <i className="fas fa-home me-2"></i>
                                Return to Home
                            </Button>
                        </div>

                        <div className="unauthorized-contact mt-4">
                            <p className="text-muted">
                                <i className="fas fa-headset me-2"></i>
                                If you believe this is an error, please contact the system administrator.
                            </p>
                        </div>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Unauthorized;